<mat-tab-group
    [ngClass]="{'lv-mat-tab-group': uiLayout !== uiLayoutEnum.TAB_MENU_NACH_GRUPPEN || !showMenu}"
    animationDuration="0ms" [dynamicHeight]="true" (focusChange)="onSelectedFocusChange($event)"
    [selectedIndex]="menuIndex$ | async">
  <ng-container *ngIf="uiLayout === uiLayoutEnum.ALLE_SEITEN">
    <mat-tab>
      <ng-container *ngFor="let gruppe of menu?.UIMenuGruppen,trackBy: trackByGruppe">
        <ng-container *ngFor="let seite of gruppe.UIMenuSeiten,trackBy: trackBySeite">
          <lv-uiartefakt-container class="lv-artefakt-tab"
                                   [uiArtefakte]="seite.UIArtefakt">
          </lv-uiartefakt-container>
        </ng-container>
      </ng-container>
    </mat-tab>
  </ng-container>
  <ng-container *ngIf="uiLayout === uiLayoutEnum.TAB_MENU_NACH_GRUPPEN">
    <ng-container *ngFor="let gruppe of menu?.UIMenuGruppen,trackBy: trackByGruppe">
      <mat-tab label="{{gruppe.MenuTitel}}">
        <ng-container *ngFor="let seite of gruppe.UIMenuSeiten,trackBy: trackBySeite">
          <lv-uiartefakt-container class="lv-artefakt-tab"
                                   [uiArtefakte]="seite.UIArtefakt">
          </lv-uiartefakt-container>
        </ng-container>
        <div class="lv-pflichtfeld-hinweis" *ngIf="hasPflichtfelder.get(gruppe.Identifikator)" [innerHTML]="'INFOTEXT.PFLICHTFELD_ANGABE' | translate"></div>
        <div class="lv-weiter-zurueck-buttons" *ngIf="showWorkflowButtons">
          <button [ngClass]="{'lv-hidden-weiter-zurueck-buttons': !gruppe.ZurueckButtonLabel}"
                  mat-raised-button
                  (click)="onZurueckClicked(gruppe.MenuTitel)">{{gruppe.ZurueckButtonLabel}}</button>
          <button [ngClass]="{'lv-hidden-weiter-zurueck-buttons': !gruppe.WeiterButtonLabel}"
                  mat-raised-button
                  (click)="onWeiterClicked(gruppe.MenuTitel)">{{gruppe.WeiterButtonLabel}}
          </button>
        </div>
      </mat-tab>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="uiLayout === uiLayoutEnum.NAVIGATION_MENU">
    <ng-container *ngFor="let gruppe of menu?.UIMenuGruppen,trackBy: trackByGruppe">
      <ng-container *ngFor="let seite of gruppe.UIMenuSeiten,trackBy: trackBySeite">
        <mat-tab label="{{seite.MenuTitel}}">
          <div class="lv-seiten-titel"
               [ngClass]="!!seite?.Ausrichtung ? seite?.Ausrichtung : uiAusrichtung">{{seite.Titel}}</div>
          <lv-uiartefakt-container class="lv-artefakt-tab"
                                   [uiArtefakte]="seite.UIArtefakt">
          </lv-uiartefakt-container>
          <div class="lv-pflichtfeld-hinweis" *ngIf="hasPflichtfelder.get(seite.Identifikator)" [innerHTML]="'INFOTEXT.PFLICHTFELD_ANGABE' | translate"></div>
          <div class="lv-weiter-zurueck-buttons" *ngIf="showWorkflowButtons">
            <button [ngClass]="{'lv-hidden-weiter-zurueck-buttons': !seite.ZurueckButtonLabel}"
                    mat-raised-button
                    (click)="onZurueckClicked(gruppe.MenuTitel)">
              <div *ngIf="!!uiControlsRequestPending && clickedButton === 'zurueck'" class="lv-button-spinner">
                <mat-progress-spinner class="lv-progress-spinner-black" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
              </div>
              <div [ngClass]="{'lv-hide-zurueck-label-tab': !!uiControlsRequestPending && clickedButton === 'zurueck'}">
                {{seite.ZurueckButtonLabel}}
              </div>
            </button>
            <button [ngClass]="{'lv-hidden-weiter-zurueck-buttons': !seite.WeiterButtonLabel}"
                    mat-raised-button
                    (click)="onWeiterClicked(gruppe.MenuTitel)">
              <div *ngIf="!!uiControlsRequestPending && clickedButton === 'weiter'" class="lv-button-spinner">
                <mat-progress-spinner class="lv-progress-spinner-black" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
              </div>
              <div [ngClass]="{'lv-hide-weiter-label-tab': !!uiControlsRequestPending && clickedButton === 'weiter'}">
                {{seite.WeiterButtonLabel}}
              </div>
            </button>
          </div>
        </mat-tab>
      </ng-container>
    </ng-container>
  </ng-container>
</mat-tab-group>
